import { Config } from './config.model';
var ConfigService = /** @class */ (function () {
    function ConfigService() {
    }
    Object.defineProperty(ConfigService.prototype, "config", {
        // noinspection JSMethodCanBeStatic
        get: function () {
            return ConfigService.staticConfig;
        },
        enumerable: true,
        configurable: true
    });
    ConfigService.SET_CONFIG = function (rawConfig) {
        this.staticConfig = new Config(rawConfig);
    };
    return ConfigService;
}());
export { ConfigService };
